import DifferenceIcon from '@mui/icons-material/Difference';
import { Popover } from '@mui/material';
import { useId, useState } from 'react';

const DifferencesPopover = ({ show, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (!show) return null;

  return (
    <>
      <span
        aria-owns={open ? `mouse-over-popover-${id}` : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <DifferenceIcon
          style={{
            width: '1rem',
            height: '1rem',
          }}
        />
      </span>
      <Popover
        id={`mouse-over-popover-${id}`}
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className="diff-popover-container">
          <p>Diferencias</p>
          <div>{children}</div>
        </div>
      </Popover>
    </>
  );
};

export default DifferencesPopover;
